var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Delete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.667 1.334c0-.369.298-.667.666-.667h5.334a.667.667 0 1 1 0 1.333H5.333a.667.667 0 0 1-.666-.666M.667 4c0-.368.298-.666.666-.666h13.334a.667.667 0 1 1 0 1.333h-.707l-.472 7.541a3.333 3.333 0 0 1-3.326 3.126H5.839a3.333 3.333 0 0 1-3.327-3.126L2.04 4.667h-.707A.667.667 0 0 1 .667 4m2.71.667.466 7.458A2 2 0 0 0 5.839 14h4.323a2 2 0 0 0 1.996-1.875l.466-7.458zm3.29 2.667c.368 0 .666.298.666.666v2.667a.667.667 0 1 1-1.333 0V8c0-.368.299-.666.667-.666M10 8a.667.667 0 0 0-1.333 0v2.667a.667.667 0 1 0 1.333 0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Delete_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDelete;